import React, { Component } from 'react'
import { Layout, Row, Col, Icon } from 'antd'

export default class Details extends Component<any, any> {
    state = {
        open: false
    }
    toggleVisibility = () => {
        this.setState(prevState => ({ open: !prevState.open }))
    }
    render() {
        const { open } = this.state
        const { record_id, terms_and_condition, deductible, company_name } = this.props
        return (
            <div style={{ cursor: 'pointer' }} onClick={() => this.toggleVisibility()}>
                <div style={{ padding: '0.4rem 0' }}>
                    <Icon type={open ? 'down' : 'left'} style={{ fontSize: '0.8rem', marginLeft: '0.2rem' }} />
                    <span style={{ marginLeft: '0.2rem' }}>{company_name}</span> |<span>מזהה תנאי: {record_id} | </span>
                    <span>{deductible ? deductible : 'אין מידע על השתתפות עצמית'}</span>
                </div>
                <div
                    style={{ display: `${open ? 'block' : 'none'}` }}
                    dangerouslySetInnerHTML={{ __html: terms_and_condition }}
                />
            </div>
        )
    }
}
